import { useState, useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { getAuthToken, setTokenExpiredCallback } from '../config/api'
import TokenExpiredModal from './TokenExpiredModal'

const AdminProtectedRoute = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false)
  const [loading, setLoading] = useState(true)
  const [showTokenExpiredModal, setShowTokenExpiredModal] = useState(false)
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    const checkAuth = () => {
      const token = getAuthToken()
      if (!token) {
        // Eğer admin sayfalarındaysa login'e yönlendir
        if (location.pathname.startsWith('/admin') && location.pathname !== '/admin/login') {
          navigate('/admin/login', { replace: true })
        }
        return
      }
      setIsAuthenticated(true)
      setLoading(false)
    }

    // Token expired callback'ini ayarla
    const handleTokenExpired = () => {
      setShowTokenExpiredModal(true)
    }

    setTokenExpiredCallback(handleTokenExpired)
    checkAuth()

    // Cleanup
    return () => {
      setTokenExpiredCallback(null)
    }
  }, [navigate, location.pathname])

  const handleTokenExpired = () => {
    setShowTokenExpiredModal(false)
    setIsAuthenticated(false)
    navigate('/admin/login', { replace: true })
  }

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Yükleniyor...</p>
        </div>
      </div>
    )
  }

  if (!isAuthenticated) {
    return null
  }

  return (
    <>
      {children}
      <TokenExpiredModal 
        isOpen={showTokenExpiredModal} 
        onClose={handleTokenExpired} 
      />
    </>
  )
}

export default AdminProtectedRoute
